function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#6D6E71",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M5.498 4.102v7.985h4.742v1.426H4.102V4.102h1.396zm8.597 0v3.694h4.407V4.102h1.396v9.41h-1.396V9.208h-4.407v4.306h-1.397V4.102h1.397z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M4.102 16.451h15.811v3.447H4.102z",
  opacity: 0.7
}));

var SvgIcLh = function SvgIcLh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_lh.89d8b56e.svg";
export { ForwardRef as ReactComponent };